import * as actionTypes from './actionTypes';

import { createActionObject, getNoArgDispatcherFunc } from '../../helpers/common';
import { fetchStationTimeOffset } from '../../helpers/api';

import * as api from '../api';

export const getStationTimeOffset = station => dispatch => {
  var targetDate = new Date();
  var timestamp = targetDate.getTime() / 1000 + targetDate.getTimezoneOffset() * 60 // Current UTC 
  return fetchStationTimeOffset(timestamp, station.latitude, station.longitude)
    .then(stationTimeOffset => dispatch(
      createActionObject(
        actionTypes.SET_STATION_TIME_OFFSET,
        { stationTimeOffset }
      )
    ));
}

export const clearStationData = getNoArgDispatcherFunc(actionTypes.CLEAR_STATION_DATA);


export const callStnTotalize = (stnTitle) => dispatch => {
  api.getTotalize(stnTitle)
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(
          createActionObject(
            actionTypes.GET_TOTALIZE,
            { data: data }
          )
        )
      }else if (status === 500) {
        dispatch(
          createActionObject(
            actionTypes.GET_TOTALIZE,
            { data: null }
          )
        )
      }
    });
}

// export const addFastData = record => dispatch => {
//   dispatch(
//     createActionObject(
//       actionTypes.ADD_LIVE_STATION_RECORD,
//       {
//         record,
//         graphDataItem: [
//           new Date(record.timestamp),
//           record.pyranometer,
//           record.irradiance,
//           record.activePower
//         ]
//       }
//     )
//   )
// }


export const addFastData = record => dispatch => {
  // Check for null values in the essential properties
  if (
    record &&
    record.timestamp !== null &&
    record.pyranometer !== null &&
    record.irradiance !== null &&
    record.activePower !== null
  ) {
    dispatch(
      createActionObject(
        actionTypes.ADD_LIVE_STATION_RECORD,
        {
          record,
          graphDataItem: [
            new Date(record.timestamp),
            record.pyranometer,
            record.irradiance,
            record.activePower
          ]
        }
      )
    );
  } else {
    // Handle the case when any essential property is null
    dispatch(
      createActionObject(
        actionTypes.ADD_LIVE_STATION_RECORD_FAILURE,
        { message: "Some essential properties in the record are null." }
      )
    );
  }
};


export const selectStation = stationId => dispatch => {
  dispatch(
    createActionObject(
      actionTypes.SELECT_LIVE_STATION,
      { stationId }
    )
  );
}

export const toggleStationListDialog = getNoArgDispatcherFunc(actionTypes.TOGGLE_STATION_LIST_DIALOG);

export const setSitePhotoDisplayIntervalId = intervalId => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SITE_PHOTOS_DISPLAY_INTERVAL_ID,
    { intervalId }
  )
);

export const setSelectedPhotoIndex = index => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SITE_PHOTOINDEX,
    { index }
  )
);

export const setSitePhotos = photos => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SITE_PHOTOS,
    { photos }
  )
);